import { Alert, Box, Button, Link } from '@mui/material';

const stripePortalLoginUrl =
  (import.meta.env.VITE_STRIPE_BILLING_PORTAL_LOGIN_URL as string | undefined)?.trim() ?? '';

const billingPortalHref = stripePortalLoginUrl || '/admin/users';

const messages: Record<string, string> = {
  payment_failed:
    'Your most recent payment has failed. Please update your payment method.',
  invoice_overdue:
    'You have an overdue invoice. Please resolve it to avoid service interruption.',
};

export const BillingAlertBanner = ({ billingAlertType }: { billingAlertType: string }) => {
  const message = messages[billingAlertType] ?? 'There is a billing issue with your account.';
  return (
    <Box sx={{ width: '100%' }}>
      <Alert
        severity="warning"
        variant="filled"
        sx={{ borderRadius: 0, display: 'flex', alignItems: 'center' }}
        action={
          <Button
            color="inherit"
            size="small"
            component={Link}
            href={billingPortalHref}
            target={stripePortalLoginUrl ? '_blank' : '_self'}
            rel="noopener noreferrer"
            sx={{ fontWeight: 700, whiteSpace: 'nowrap' }}
          >
            Billing Portal
          </Button>
        }
      >
        {message}
      </Alert>
    </Box>
  );
};
